const downloadBlob = (filename, blob) => {
  const url = globalThis.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
};

export default downloadBlob;
